import React from 'react';
import { Button, Badge } from '@dopomogai/ui';

type Props = {
	agentName: string;
	heroTitle: string;
	avatarUrl?: string;
	onPrimaryCta?: () => void;
};

export function AgentInvestHero({ agentName, heroTitle, avatarUrl, onPrimaryCta }: Props) {
	return (
		<section className="bg-slate-50 border-b-2 border-black">
			<div className="max-w-6xl mx-auto px-6 py-12 md:py-16">
				<div className="grid md:grid-cols-3 gap-8 items-center">
					<div className="md:col-span-2 flex items-start gap-4">
						{avatarUrl && (
							<img src={avatarUrl} alt={`${agentName} avatar`} className="w-20 h-20 rounded-full border-2 border-black object-cover" />
						)}
						<div>
							<h1 className="text-3xl md:text-4xl font-extrabold tracking-tight">{agentName}</h1>
							<p className="mt-2 text-slate-700 text-lg">{heroTitle}</p>
							<div className="mt-3 inline-flex items-center gap-2">
								<Badge text="Seed round" accentColor="green" />
							</div>
							<div className="mt-6">
								<Button text="Invest now" onClick={onPrimaryCta} />
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}


